var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import TopNavigation from '../TopNavigation';
import Loading from '../Loading';
import Validations from '../../util/Validations';
import { useTranslation } from '../../i18n';
import { getVestaErrorMessage, getVestaSDK, getVestaValidationConfig, } from '../../services/VestaService';
import { Container, Content, Description, ErrorMessage, Field, FieldLabel, Form, Input, PrimaryButton, Title, } from './styles';
var showFeedback = function (_a) {
    var type = _a.type, message = _a.message;
    if (type === 'success') {
        toast.success(message);
        return;
    }
    console.error(message);
};
var normalizeCpf = function (value) { return value.replace(/\D/g, ''); };
var normalizePrivateBirthDate = function (value) { return value.replace(/\D/g, ''); };
var normalizeFullName = function (value) { return value
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .toUpperCase(); };
var isValidBirthDate = function (value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value))
        return false;
    var _a = value.split('-').map(Number), year = _a[0], month = _a[1], day = _a[2];
    var date = new Date(year, month - 1, day);
    return date.getFullYear() === year
        && date.getMonth() === month - 1
        && date.getDate() === day
        && date <= new Date();
};
var StepPasskey = function (_a) {
    var step = _a.step, saving = _a.saving, useEnrichedData = _a.useEnrichedData, onComplete = _a.onComplete;
    var form = useSelector(function (state) { return state.form; }).form;
    var t = useTranslation().t;
    var currentStep = form.steps[step];
    var _b = React.useState(true), checking = _b[0], setChecking = _b[1];
    var _c = React.useState(false), credentialReady = _c[0], setCredentialReady = _c[1];
    var _d = React.useState(false), busy = _d[0], setBusy = _d[1];
    var _e = React.useState(false), hasCredential = _e[0], setHasCredential = _e[1];
    var _f = React.useState(false), showForm = _f[0], setShowForm = _f[1];
    var _g = React.useState(false), manualFallback = _g[0], setManualFallback = _g[1];
    var _h = React.useState(''), fullName = _h[0], setFullName = _h[1];
    var _j = React.useState(''), cpf = _j[0], setCpf = _j[1];
    var _k = React.useState(''), birthDate = _k[0], setBirthDate = _k[1];
    var _l = React.useState({}), errors = _l[0], setErrors = _l[1];
    var _m = React.useState(''), errorMessage = _m[0], setErrorMessage = _m[1];
    var credentialCheck = React.useRef(null);
    var automaticFlowStarted = React.useRef(false);
    var mounted = React.useRef(true);
    React.useEffect(function () {
        mounted.current = true;
        return function () { mounted.current = false; };
    }, []);
    var validateForm = function () {
        var nextErrors = {};
        var normalizedName = normalizeFullName(fullName);
        var normalizedCpf = normalizeCpf(cpf);
        if (!normalizedName)
            nextErrors.fullName = t('passkey.fullNameRequired');
        if (!Validations.validateCPF(normalizedCpf))
            nextErrors.cpf = t('passkey.cpfInvalid');
        if (!isValidBirthDate(birthDate))
            nextErrors.birthDate = t('passkey.birthDateInvalid');
        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };
    var complete = function (result, feedback) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onComplete(result)];
                case 1:
                    _a.sent();
                    showFeedback(feedback);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('[passkey.onComplete]', error_1);
                    message = t('passkey.saveFailed');
                    if (mounted.current)
                        setErrorMessage(message);
                    console.error(message);
                    if (mounted.current)
                        setBusy(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var executePasskey = function (userData, registered) { return __awaiter(void 0, void 0, void 0, function () {
        var vesta, validationConfig, result, status_1, feedback, completionResult, error_2, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setBusy(true);
                    setErrorMessage('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 6]);
                    if (!userData.fullName
                        || !Validations.validateCPF(userData.cpf)
                        || !isValidBirthDate(userData.birthDate)) {
                        throw new Error(t('passkey.dataMissing'));
                    }
                    vesta = getVestaSDK();
                    validationConfig = getVestaValidationConfig();
                    return [4 /*yield*/, vesta.smartEnroll({
                            userData: __assign(__assign({}, userData), { kycLevel: 'pending', kycMethod: 'document_verification' }),
                            privateInputs: {
                                cpf: userData.cpf,
                                birthDate: normalizePrivateBirthDate(userData.birthDate),
                                fullName: userData.fullName,
                            },
                            verifierId: validationConfig.verifierId,
                            minKycLevel: validationConfig.minKycLevel,
                        })];
                case 2:
                    result = _a.sent();
                    status_1 = result.authenticated
                        ? (result.isNewUser ? 'REGISTER_REQUESTED' : 'AUTHENTICATED')
                        : 'FAILED';
                    feedback = status_1 === 'AUTHENTICATED'
                        ? {
                            type: 'success',
                            message: t('passkey.authSuccess'),
                        }
                        : status_1 === 'REGISTER_REQUESTED'
                            ? {
                                type: 'success',
                                message: t('passkey.registerSuccess'),
                            }
                            : {
                                type: 'error',
                                message: registered
                                    ? t('passkey.authFailed')
                                    : t('passkey.registerFailed'),
                            };
                    completionResult = status_1 === 'FAILED'
                        ? { passkey_status: status_1 }
                        : { passkey_status: status_1, cpf: userData.cpf };
                    return [4 /*yield*/, complete(completionResult, feedback)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    console.error('[passkey.flow]', error_2);
                    message = getVestaErrorMessage(error_2);
                    return [4 /*yield*/, complete({ passkey_status: 'FAILED' }, {
                            type: 'error',
                            message: t('passkey.continuesNormally', { message: message }),
                        })];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        var active = true;
        if (!credentialCheck.current) {
            credentialCheck.current = (function () { return __awaiter(void 0, void 0, void 0, function () {
                var vesta, error_3;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            vesta = getVestaSDK();
                            if (!vesta.isPasskeySupported()) {
                                throw new Error(t('passkey.notSupported'));
                            }
                            _a = { ok: true };
                            return [4 /*yield*/, vesta.hasRegisteredCredential()];
                        case 1: return [2 /*return*/, (_a.registered = _b.sent(), _a)];
                        case 2:
                            error_3 = _b.sent();
                            return [2 /*return*/, { ok: false, error: error_3 }];
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
        }
        var checkCredential = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, credentialCheck.current];
                    case 1:
                        result = _a.sent();
                        if (!active)
                            return [2 /*return*/];
                        if (!!result.ok) return [3 /*break*/, 3];
                        message = getVestaErrorMessage(result.error);
                        setErrorMessage(message);
                        setChecking(false);
                        toast.error(message, { toastId: 'passkey-credential-check-error' });
                        return [4 /*yield*/, complete({ passkey_status: 'FAILED' }, {
                                type: 'error',
                                message: t('passkey.continuesNormally', { message: message }),
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        setHasCredential(result.registered);
                        setCredentialReady(true);
                        setChecking(false);
                        return [2 /*return*/];
                }
            });
        }); };
        checkCredential();
        return function () { active = false; };
    }, []);
    React.useEffect(function () {
        if (!useEnrichedData || !credentialReady || automaticFlowStarted.current)
            return;
        automaticFlowStarted.current = true;
        var getFieldValue = function (alias) {
            var _a;
            var value = (_a = currentStep.fields.find(function (field) { return field.field === alias; })) === null || _a === void 0 ? void 0 : _a.value;
            return typeof value === 'string' ? value : '';
        };
        var rawCpf = getFieldValue('cpf');
        if (!rawCpf.trim()) {
            setFullName('');
            setCpf('');
            setBirthDate('');
            setErrors({});
            setManualFallback(true);
            setShowForm(true);
            return;
        }
        executePasskey({
            cpf: normalizeCpf(rawCpf),
            fullName: normalizeFullName(getFieldValue('name')),
            birthDate: getFieldValue('birth_date').trim(),
        }, hasCredential);
    }, [credentialReady, useEnrichedData]);
    var submit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (busy || saving || !validateForm())
                        return [2 /*return*/];
                    return [4 /*yield*/, executePasskey({
                            cpf: normalizeCpf(cpf),
                            fullName: normalizeFullName(fullName),
                            birthDate: birthDate,
                        }, hasCredential)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var isLoading = checking || busy || saving;
    var isManualMode = !useEnrichedData || manualFallback;
    var actionLabel = hasCredential ? t('passkey.loginAction') : t('passkey.registerAction');
    var defaultDescription = isManualMode
        ? hasCredential
            ? t('passkey.descriptionLogin')
            : t('passkey.descriptionRegister')
        : t('passkey.descriptionValidating');
    return (React.createElement(Container, null,
        React.createElement(TopNavigation, { showLogo: true, showBackButton: currentStep.goBack, title: currentStep.showStepName ? currentStep.stepName : '', headerTransparent: currentStep.headerTransparent }),
        React.createElement(Content, null,
            React.createElement(Title, null, currentStep.formTitle || t('passkey.title')),
            React.createElement(Description, null, currentStep.formSubtitle || defaultDescription),
            errorMessage && React.createElement(ErrorMessage, { role: "alert" }, errorMessage),
            isLoading && React.createElement(Loading, { customStyle: { position: 'static', height: 80, margin: '0 auto' } }),
            isManualMode && !checking && !showForm && !errorMessage && (React.createElement(PrimaryButton, { disabled: isLoading, onClick: function () { return setShowForm(true); } }, actionLabel)),
            isManualMode && showForm && (React.createElement(Form, { onSubmit: submit, noValidate: true },
                React.createElement(Field, null,
                    React.createElement(FieldLabel, { htmlFor: "passkey-full-name" }, t('passkey.fullNameLabel')),
                    React.createElement(Input, { id: "passkey-full-name", autoComplete: "name", value: fullName, onChange: function (event) { return setFullName(event.target.value); }, disabled: isLoading, required: true }),
                    errors.fullName && React.createElement(ErrorMessage, null, errors.fullName)),
                React.createElement(Field, null,
                    React.createElement(FieldLabel, { htmlFor: "passkey-cpf" }, t('passkey.cpfLabel')),
                    React.createElement(Input, { id: "passkey-cpf", inputMode: "numeric", autoComplete: "off", maxLength: 14, value: cpf, onChange: function (event) { return setCpf(event.target.value); }, disabled: isLoading, required: true }),
                    errors.cpf && React.createElement(ErrorMessage, null, errors.cpf)),
                React.createElement(Field, null,
                    React.createElement(FieldLabel, { htmlFor: "passkey-birth-date" }, t('passkey.birthDateLabel')),
                    React.createElement(Input, { id: "passkey-birth-date", type: "date", value: birthDate, onChange: function (event) { return setBirthDate(event.target.value); }, disabled: isLoading, required: true }),
                    errors.birthDate && React.createElement(ErrorMessage, null, errors.birthDate)),
                React.createElement(PrimaryButton, { type: "submit", disabled: isLoading }, actionLabel))))));
};
export default StepPasskey;
